export const Colors = [
	'#88082F', // Maroon
	'#B70024', // Cherry
	'#E74450', // Coral
	'#04267D', // Midnight
	'#003D71', // Navy
	'#146998', // Cerulean
	'#82BBDD', // Sky
	'#553B86', // Deep Purple
	'#805FBF', // Grape
	'#9D8FE1', // Lilac
	'#757786', // Slate
	'#27ae60', // Emerald
	'#97A6AC', // Silver
	'#CD5C5C', // Indian Red
	'#FA8072', // Salmon
	'#E9967A', // Dark Salmon
	'#FFA07A', // Light Salmon
	'#DB7093', // Pale Violet Red
	'#FF6347', // Tomato
	'#FFD700', // Gold
	'#BDB76B', // Khaki
	'#DDA0DD', // Plum
	'#DA70D6', // Orchid
	'#8A2BE2', // Blue Lilac
	'#6A5ACD', // Slate Blue
	'#7FFF00', // Chartreuse
	'#32CD32', // Lime
	'#98FB98', // Pale Green
	'#2E8B57', // Sea Green
	'#9ACD32', // Yellow Green
	'#66CDAA', // Medium Aquamarine
	'#00FFFF', // Aqua
	'#AFEEEE', // Pale Turquoise
	'#40E0D0', // Turquoise
	'#5F9EA0', // Cadet Blue
	'#B0C4DE', // Steel Blue
	'#87CEEB', // Dodger Blue
	'#F5DEB3', // Wheat
	'#DAA520', // Goldenrod
	'#BC8F8F', // Rosy Brown
	'#FF8C00', // Dark Orange
	'#FFDAB9', // Peach
	'#D8BFD8', // Thistle
	'#EE82EE', // Violet
	'#BA55D3', // Medium Orchid
	'#8B008B', // Dark Magenta
	'#9400D3', // Dark Violet
	'#4B0082', // Indigo
	'#00FF7F', // Spring Green
	'#808000', // Olive
	'#7FFFD4', // Aquamarine
	'#B0E0E6' // Powder Blue
];
